import { addQueryParamsToUrl } from '@healthhub/react-ui';
import type { NavigateFunction } from 'react-router';

import {
  ADD_CAREGIVERS_RECEIVED_APPROVAL_PATH,
  CANCEL_CARE_GIVERS_PATH,
  UPDATE_CARE_GIVERS_DETAILS_PATH,
} from '@shared/constants/paths';

interface NavigateToManageCaregiverParams {
  displayName?: string;
  email?: string;
  id?: string;
  isCaregiverFlow: boolean;
  isRequestPending: boolean;
  mid: string;
  navigate: NavigateFunction;
  nric?: string;
  relationship?: string;
}

export const navigateToManageCaregiver = ({
  displayName,
  email,
  id,
  isCaregiverFlow,
  isRequestPending,
  mid,
  navigate,
  nric,
  relationship,
}: NavigateToManageCaregiverParams) => {
  if (isRequestPending && isCaregiverFlow) {
    navigate(addQueryParamsToUrl(CANCEL_CARE_GIVERS_PATH, { displayName, email, id, mid, nric, relationship }));
    return;
  }

  if (!isRequestPending) {
    navigate(addQueryParamsToUrl(UPDATE_CARE_GIVERS_DETAILS_PATH, { displayName, mid }));
    return;
  }

  navigate(addQueryParamsToUrl(ADD_CAREGIVERS_RECEIVED_APPROVAL_PATH, { mid }));
};
